const UncheckSVG = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="18"
        cy="18"
        r="16"
        fill="white"
        stroke="#DADADA"
        strokeWidth="3"
      />
    </svg>
  );
};
export default UncheckSVG;
